import React, { FC, Ref, useEffect, useRef, useState } from 'react';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import styled from 'styled-components';
import { LabelValidator } from './label-validador';
import { InputProps } from './props';
import { StyledInput, StyledLabel, Container } from './styles';

const CustomInput = styled(StyledInput)`
    padding: 17px 28px 1px 10px;
`;

const CustomLabel = styled(StyledLabel)`
    padding-right: 25px;
`;

const EnabledPasswordIcon = styled(IoMdEye)`
    position: absolute;
    right: 6px;
    top: 13px;
    font-size: 21px;
    color: #666;
    cursor: pointer;
`;

const DisabledPasswordIcon = styled(IoMdEyeOff)`
    position: absolute;
    right: 6px;
    top: 13px;
    font-size: 21px;
    color: #666;
    cursor: pointer;
`;

export const InputPassword: FC<InputProps> = ({
    label,
    value,
    color = '#47516f',
    isValid,
    style,
    onChange,
    ...rest
}) => {
    const ref: Ref<HTMLInputElement> = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <CustomInput
                {...rest}
                isValid={isValid}
                type={showPassword ? 'text' : 'password'}
                value={text}
                ref={ref}
                onChange={(ev: any) => {
                    setText(ev.target.value);
                    return onChange?.(ev);
                }}
                placeholder=''
            />
            {!showPassword ? (
                <DisabledPasswordIcon onClick={() => setShowPassword(true)} />
            ) : (
                <EnabledPasswordIcon onClick={() => setShowPassword(false)} />
            )}
            <CustomLabel active={focused || text !== ''}>{label}</CustomLabel>
            <LabelValidator isValid={isValid} />
        </Container>
    );
};
